module.exports = __webpack_public_path__ + "img/18.959404e1.png";